const UnlockIcon = ({ className }: { className?: string }) => {
	return (
		<svg
			width="46"
			height="61"
			viewBox="0 0 46 61"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g clipPath="url(#clip0_9713_34024)">
				<path
					d="M0 61.0005H46L37.1635 31.4825C40.2258 28.9968 42.3602 25.7625 43.2886 22.2013C44.2171 18.64 43.8964 14.9169 42.3684 11.5172C40.8405 8.11753 38.1761 5.19893 34.7226 3.14179C31.269 1.08465 27.1865 -0.015625 23.007 -0.015625C18.8275 -0.015625 14.745 1.08465 11.2914 3.14179C7.83788 5.19893 5.1735 8.11753 3.64554 11.5172C2.11759 14.9169 1.79692 18.64 2.72534 22.2013C3.65375 25.7625 5.78819 28.9968 8.85046 31.4825L0 61.0005Z"
					fill="url(#paint0_linear_9713_34024)"
				/>
				<path
					d="M37.1635 31.4824L46 61.0003H28.341V31.4824H37.1635Z"
					fill="url(#paint1_linear_9713_34024)"
				/>
				<path
					d="M37.1758 61.0008L28.3393 31.4829C31.122 29.2216 33.1426 26.3374 34.1818 23.1432C35.221 19.9491 35.239 16.5672 34.2339 13.3648C33.2288 10.1623 31.239 7.26173 28.4805 4.97791C25.7221 2.69408 22.3004 1.11432 18.587 0.410156C14.8739 1.11474 11.4526 2.69481 8.6946 4.97881C5.93657 7.26281 3.9472 10.1635 2.94248 13.3658C1.93777 16.5682 1.95609 19.95 2.99548 23.1439C4.03486 26.3378 6.05558 29.2218 8.83824 31.4829L6.39143 39.6391L5.63292 42.1714L-0.00522232 61.0008H37.1758Z"
					fill="#1A2133"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_9713_34024"
					x1="23"
					y1="31.2596"
					x2="23"
					y2="3.14988"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#005EFF" />
					<stop offset="1" stop-color="#005EFF" stop-opacity="0.36" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_9713_34024"
					x1="37.1705"
					y1="58.752"
					x2="37.1705"
					y2="4.3411"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#005EFF" />
					<stop offset="1" stop-color="#005EFF" stop-opacity="0.45" />
				</linearGradient>
				<clipPath id="clip0_9713_34024">
					<rect width="46" height="61" fill="white" transform="matrix(-1 0 0 1 46 0)" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default UnlockIcon;
